import { Flex } from "@mantine/core";
import { useCallback } from "react";
import { useController, useFormContext } from "react-hook-form";

import TimeInputWithTimeZone from "../TimeInputWithTimeZone/TimeInputWithTimeZone";

interface DualTimeInputProps {
  value: any;
  id: string;
  idx?: number;
  required: boolean | string;
  domId?: string;
  rowIndex?: number;
  [key: string]: any;
}

interface DualTimeValue {
  timeLt?: string;
  timeUtc?: string;
}

const DualTimeInput = ({
  value,
  id,
  idx,
  required,
  domId,
  rowIndex,
  ...props
}: DualTimeInputProps) => {
  const { control, getValues } = useFormContext();

  // Controller for the main field that stores both times
  const {
    field: { onChange },
  } = useController({
    name: id,
    control,
    defaultValue: value || { timeLt: "", timeUtc: "" },
  });

  // Handle blur events to update the main field
  const handleTimeChange = useCallback(() => {
    const ltTimeValue = getValues(`${id}-LT.time`);
    const utcTimeValue = getValues(`${id}-UTC.time`);

    const newValue: DualTimeValue = {
      timeLt: ltTimeValue || "",
      timeUtc: utcTimeValue || "",
    };

    onChange(newValue);
  }, [getValues, id, onChange]);

  return (
    <Flex gap="0.5rem">
      <TimeInputWithTimeZone
        {...props}
        id={`${id}-LT`}
        idx={idx}
        rowIndex={rowIndex}
        domId={domId}
        forceValue="LT"
        isLTorUTCOnly={true}
        value={value?.timeLt || ""}
        required={typeof required === "boolean" ? required : false}
        onTimeChange={handleTimeChange}
      />
      <TimeInputWithTimeZone
        {...props}
        id={`${id}-UTC`}
        idx={idx}
        rowIndex={rowIndex}
        domId={domId}
        forceValue="UTC"
        isLTorUTCOnly={true}
        value={value?.timeUtc || ""}
        required={typeof required === "boolean" ? required : false}
        onTimeChange={handleTimeChange}
      />
    </Flex>
  );
};

export default DualTimeInput;
